"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./WirelessContents.scss");
var utils_1 = require("@idp/ui-components/utils");
var ui_components_1 = require("@idp/ui-components");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var WirelessContents = /** @class */ (function (_super) {
    __extends(WirelessContents, _super);
    function WirelessContents(props) {
        var _this = _super.call(this, props) || this;
        _this.getAalPlanPriceValue = _this.getAalPlanPriceValue.bind(_this);
        return _this;
    }
    WirelessContents.prototype.render = function () {
        var _a;
        return (React.createElement(React.Fragment, null, this.props.losg.losgType === 'AL' &&
            React.createElement("section", { className: styles.aalContainer },
                React.createElement("article", { className: styles.aalContent },
                    React.createElement("span", { className: styles.aalNewLabel }, "New"),
                    React.createElement(ui_components_1.RichText, { testId: utils_1.default('Wireless', 'AAL', 'RatePlan'), data: { isDecodingRequired: false, text: this.getAalPlanPriceValue(this.props.losg).planDisplayName } })),
                !((_a = this.props) === null || _a === void 0 ? void 0 : _a.hidePrice) &&
                    React.createElement("article", null,
                        React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('Wireless', 'AAL', 'RatePlan_Price'), data: { billingNote: '/mo.', price: this.getAalPlanPriceValue(this.props.losg).planPriceValue }, options: { className: styles.aalPrice, decimalPoints: 2, overrideAccessibility: true,
                                type: PriceContainerProps_1.PricingType.XSMALL } })))));
    };
    WirelessContents.prototype.getAalPlanPriceValue = function (losg) {
        var _a;
        var aalPlanPriceValue = { planDisplayName: '', planPriceValue: 0 };
        if (((_a = losg.losgType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'AL') {
            Object.values(losg === null || losg === void 0 ? void 0 : losg.lineItems).forEach(function (lineItemData) {
                var _a;
                if ((lineItemData === null || lineItemData === void 0 ? void 0 : lineItemData.itemType.toUpperCase()) === 'SHAREDDATAFEATURE') {
                    aalPlanPriceValue.planDisplayName = lineItemData.displayName;
                    aalPlanPriceValue.planPriceValue = (_a = lineItemData.price) === null || _a === void 0 ? void 0 : _a.amount;
                }
            });
        }
        return aalPlanPriceValue;
    };
    return WirelessContents;
}(React.Component));
exports.default = WirelessContents;
//# sourceMappingURL=WirelessContents.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/WirelessContents/WirelessContents.js
// module id = 2311
// module chunks = 8